import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../service/api_service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { EmpAttendanceModel } from '../../model'
import { HttpClient } from '@angular/common/http'
import * as $ from 'jquery';
import { Router } from "@angular/router"
import { Subscription } from 'rxjs';


@Component({
    selector: 'app-employeeattandance',
    template: require('./employeeattandance.component.html'),
    viewProviders: [ApiService]
})

export class EmployeeAttendaceComponent implements OnInit {
    EmpAttendanceData: EmpAttendanceModel = new EmpAttendanceModel();
    EmpAttendance: any = [];
    firstDate: string;
    lastDate: string;
    busy: Subscription;
    private columnDefs;
    private rowHeight;
    api: any;
    columnApi: any;
    defaultColDefine;
    private gridColumnApi;
    token:any;

    EmpAttendance_Form = new FormGroup({
        fromDate: new FormControl('', [Validators.required]),
        toDate: new FormControl('', [Validators.required]),
        status: new FormControl('', [Validators.required]),

    });

    static parameters = [ApiService, Router, HttpClient]
    constructor(private apiService: ApiService, private router: Router, private http: HttpClient) {
        this.apiService = apiService;
 

    }
 
    
    ngOnInit() {
        this.token = JSON.parse(sessionStorage.getItem("currentUser"));
        $('#filter-option').trigger('click');
        this.InitColumnDef();
        var date = new Date();
        var year = date.getFullYear();
        var month = (date.getMonth() + 1).toString().padStart(2, "0");
        var first_date = new Date(date.getFullYear(), date.getMonth(), 1);
        this.firstDate = year + '-' + month + '-' + first_date.getDate().toString().padStart(2, "0");
        this.lastDate = year + '-' + month + '-' + date.getDate().toString().padStart(2, "0");
        console.log('firstDate ', this.firstDate, this.lastDate);
        this.EmpAttendance_Form.controls['fromDate'].setValue(
            this.firstDate
        );
        this.EmpAttendance_Form.controls['toDate'].setValue(
            this.lastDate
        );
        this.EmpAttendanceData.status = "-1";
    }


    InitColumnDef() {
        this.columnDefs = [
            { headerName: 'Employee Code', field: "EmployeeCode", suppressSizeToFit: true },
            { headerName: 'Employee Name', field: "EmployeeName" },
            { headerName: 'Designation', field: "Designation" },
            { headerName: 'DOJ', field: "DOJ" },
            { headerName: 'HQ Name', field: "HQName" },
            { headerName: 'Manager', field: "Manager" },
            { headerName: 'Present', field: "Present" },
            { headerName: 'Absent', field: "Absent" },
            { headerName: 'Leave', field: "Leave" },
            { headerName: 'Holiday', field: "Holiday" },
            //{ headerName: 'Regional Holiday', field: "Holiday" },
            { headerName: 'Week Off', field: "Week Off" },
            { headerName: 'Status', field: "EmployeeStatus" },
            { headerName: 'Last Working Date', field: "Last Working Date" },
        ];
        this.rowHeight = 50;
        this.defaultColDefine = { resizable: true };
    }
    generateColumns(data: any[]) {
        let columnDefinitions = [];
        data.map(object => {
          Object
            .keys(object)
            .map(key => {
              let mappedColumn = {
                headerName: key,
                field: key
              }
              columnDefinitions.push(mappedColumn);
            })
        })
        //Remove duplicate columns
        columnDefinitions = columnDefinitions.filter((column, index, self) =>
          index === self.findIndex((colAtIndex) => (
            colAtIndex.field === column.field
          ))
        )
        return columnDefinitions;
      }

    onGridReady = (params) => {
        this.api = params.api;
        this.gridColumnApi = params.columnApi;
        this.api.showNoRowsOverlay();
    }

    onBtnExport() {
        this.api.exportDataAsExcel({ fileName: 'Employee_Attendance' });
    }



    onFilterTextBoxChanged() {
        this.api.setQuickFilter(document.querySelector<HTMLInputElement>('#filter-text-box')!.value);
    }


    getEmployeeAttandance() {
        //this.api.showLoadingOverlay();
        this.EmpAttendanceData.fromDate = this.EmpAttendance_Form.value.fromDate;
        this.EmpAttendanceData.toDate = this.EmpAttendance_Form.value.toDate;
        this.EmpAttendanceData.LoginId=this.token.id;
       // console.log(this.EmpAttendanceData);
        this.busy = this.apiService.getEmployeeAttandance(this.EmpAttendanceData).subscribe((res: any) => {
            this.EmpAttendance = res;
            console.log("respose",res)
            if(res.length > 0){
                this.columnDefs = this.generateColumns(this.EmpAttendance);
            }
            else{
                this.InitColumnDef(); 
            }
        })
    }
}
